<template>
  <div class="container">
    <div class="page-title" style="padding: 0 20px;">菜单分类</div>
    <div class="content">
      <div class="content-bottom">
        <div class="content-box">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="padding-left: 20px;">
            <el-tab-pane label="编辑大类" name="first">
              <edit-big v-if="activeName==='first'" @changeActiveName="changeActiveName"></edit-big>
            </el-tab-pane>
            <el-tab-pane label="编辑小类" name="second">
              <edit-small v-if="activeName==='second'" :firstIdProp="firstIdProp" @changeActiveName="changeActiveName"></edit-small>
            </el-tab-pane>
            <el-tab-pane label="编辑菜名" name="foodName">
              <edit-food-name v-if="activeName==='foodName'" :firstIdProp="firstIdProp" :secondIdProp="secondIdProp" @changeActiveName="changeActiveName"></edit-food-name>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <el-dialog title="在线选图" :close-on-click-modal="false" :visible.sync="dialogTableVisible" center :append-to-body='true' :lock-scroll="false" width="80%">
      <div class="">
        <div class="first-line">
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">大类</div>
            <el-select filterable @change="changeBigType" v-model="firstName" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in bigTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">小类</div>
            <el-select filterable @change="changeSmallType" v-model="secondName" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in smallTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">名称</div>
            <el-select filterable v-model="lastName" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in foodNames"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box" style="padding-left: 12px;">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </div>
        </div>
        <div class="dialog-image-box" style="width: 100%;display: flex;justify-content: center;">
          <div class="dialog-image-item" v-for="(item,index) in imgDataList" :key="index">
            <el-image style="width: 150px;height: 150px;"
              :src="baseURL + '/images'+item.imgSmallUrl"
              :preview-src-list="imageSrcList"
            >
            </el-image>
            <el-radio class="image-radio" v-model="imageRadioId" :label="index"></el-radio>
          </div>
          <div style="text-align: center;font-size: 14px;color: #909399;margin-top: 10px;" v-if="!(imgDataList && imgDataList.length > 0)">暂无数据</div>
        </div>
        <div style="display: flex;justify-content: center;margin-bottom: 10px;">
          <el-button :disabled="!imageRadioId && imageRadioId !== 0" width="80px" type="primary" size="mid" style="margin-top: 30px;" @click="confirm">确定</el-button>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[5, 10, 20, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </div>
    </el-dialog>
<!--    加类-->
    <el-dialog title="加类" :close-on-click-modal="false" :visible.sync="dialogAddSecond" center :append-to-body='true' :lock-scroll="false" width="60%">
      <div class="">
        <div class="first-line">
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">大类</div>
            <el-select filterable @change="changeBigType" v-model="firstNameForAddSecond" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in bigTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">小类</div>
            <el-select filterable v-model="secondNameForAddSecond" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in smallTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-content: center;margin-bottom: 10px;">
          <el-button :disabled="!(secondNameForAddSecond && firstNameForAddSecond)" width="80px" type="primary" size="mid" style="margin-top: 30px;" @click="addSecond">确定</el-button>
        </div>
      </div>
    </el-dialog>
<!--  加菜-->
    <el-dialog title="加菜" :close-on-click-modal="false" :visible.sync="dialogAddFoodName" center :append-to-body='true' :lock-scroll="false" width="60%">
      <div class="">
        <div class="first-line">
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">大类</div>
            <el-select filterable @change="changeBigType" v-model="firstNameForFoodName" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in bigTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">小类</div>
            <el-select filterable @change="changeSmallType" v-model="secondNameForFoodName" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in smallTypes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="date-box" style="padding-left: 12px;">
            <div class="label" style="width: 50px;text-align: right;">名称</div>
            <el-select filterable v-model="lastNameForFoodName" placeholder="请选择" style="width: 132px;">
              <el-option
                v-for="item in foodNames"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex;justify-content: center;margin-bottom: 10px;">
          <el-button :disabled="!(firstNameForFoodName && secondNameForFoodName && lastNameForFoodName)" width="80px" type="primary" size="mid" style="margin-top: 30px;" @click="addFoodName">确定</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import editBig from "./edit-big"
  import editSmall from "./edit-small"
  import editFoodName from "./edit-foodName"
  export default {
    data() {
      return {
        orderNo:'', //查询
        tableData: [],
        imgDataList: [],
        imageRadioId: '',
        changeItem:{},
        dateArr: [],
        value: '',
        shopOptions: [],  //店铺名称
        total: 0,
        pageSize: 10,
        currentPage:1,
        listLoading: false,
        type: '',
        id: '',
        idList: [],
        dialogTableVisible:false,  //添加弹框
        queryId: '',  //上个界面
        findPictureData: {},
        bigTypes: [],  //大类
        smallTypes: [],
        foodNames: [],
        firstName:'',
        secondName:'',
        lastName:'',
        dialogAddSecond: false,
        firstNameForAddSecond:'',
        secondNameForAddSecond:'',
        dialogAddFoodName: false,
        firstNameForFoodName:'',
        secondNameForFoodName:'',
        lastNameForFoodName:'',
        addFoodNameId: '',
        orderKey: '',
        timer: null,
        loading: false,
        activeName: 'first',
        createBigTypeFlag: false,
        newBigType: '',
        firstIdProp: 1,
        secondIdProp: 1,
        baseURL: ''
      };
    },
    components: {
      editBig,editSmall,editFoodName
    },
    activated () {
      this.baseURL = window.baseURL;
      this.queryId = this.$route.query.id;
      this.orderKey = this.$route.query.orderKey;
      this.findOrderInfo();
      this.queryBigTypes(); //查询大类
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
        this.firstIdProp = 1;
        this.secondIdProp = 1;
      },
      changeActiveName(activeName, data){
        switch(activeName){
          case 'second':
            this.firstIdProp = data;
            break;
          case 'foodName':
            this.firstIdProp = data.firstId;
            this.secondIdProp = data.id;
        }

        this.$nextTick(()=>{
          this.activeName = activeName;
        })
      },
      findOrderInfo(type){
        this.$http.post("/order/findOrderInfo", {id: this.queryId}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data);
              const data = res.data.data || {}
              this.tableData = data.orderInfoSecondList;
              if(type === 'down' &&  data.orderInfo && data.orderInfo.downUrl){
                const url = this.baseURL + '/images'+ data.orderInfo.downUrl;
                window.open(url)
              }
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      queryBigTypes(){
        this.$http.post(`/menuName/findFirstName`, {}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====queryOptions',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.bigTypes = res.data.data;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      changeBigType(){
        console.log('changeBigType=======')
        const data = {
          firstId: this.firstName
        }
        this.$http.post("/menuName/findSecondName", data, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.smallTypes = res.data.data;
              this.secondName = ''
              this.lastName = '';
              this.secondNameForAddSecond = ''
              this.secondNameForFoodName = ''
              this.lastNameForFoodName = ''
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      changeSmallType(){
        console.log('changeSmallType=======')
        const data = {
          secondId: this.secondName
        }
        this.$http.post("/menuName/findLastName", data, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.foodNames = res.data.data;
              this.lastName = '';
              this.lastNameForFoodName = ''
              // this.foodNames = res.data.data;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      search(){
        this.imageRadioId = ''
        this.currentPage = 1;
        const data = {
          firstId: this.firstName,
          secondId: this.secondName,
          lastId: this.lastName,
          // lastName: this.lastName
        };
        this.findPictureData = data;
        this.findPicture(this.currentPage,this.pageSize);
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.findPicture(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.findPicture(this.currentPage,this.pageSize);
      },
      back(){
        this.$router.go(-1);
      },
      changImage(value,item){
        console.log('item===',value,item);
        this.changeItem = item;
        const data = {
          firstId: item.firstId,
          secondId: value.secondId,
          lastId: item.lastId,
          lastName: item.lastName
        };
        this.findPictureData = data;
        this.findPicture(this.currentPage,this.pageSize);
      },
      findPicture(currentPage,pageSize){
        this.$http.post(`/order/findPicture/${currentPage}/${pageSize}`, this.findPictureData , { headers: {
            token: window.sessionStorage.manageToken,
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            // this.shopOptions = res.data;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.imgDataList = res.data.data.list;
              this.total = res.data.data.total;
              this.imageRadioId = ''
              this.dialogTableVisible = true;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      confirm(type,item){
        console.log('type===',type)
        item && (this.changeItem = item);
        // console.log("+++++++++",  this.imgDataList[this.imageRadioId].imgId,this.changeItem.id);
        // const imgId = this.imgDataList[this.imageRadioId].imgId;
        let data = {
          id:this.changeItem.id
        };
        type !== 'free' && (data.imgId = this.imgDataList[this.imageRadioId].imgId);
        console.log('data',data)
        this.$http.post(`/order/choosePicture`, data , { headers: {
            token: window.sessionStorage.manageToken,
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            // this.shopOptions = res.data;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              const text = type === 'free' ? '免图成功' :'换图成功'
              this.$message.success(text)
              this.dialogTableVisible = false;
              this.findOrderInfo();
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      addSecond(){
        const value = this.smallTypes.find((item,index)=>{
           return item.id === this.secondNameForAddSecond
        })
        const data = {
          orderId:this.queryId,
          secondId:this.secondNameForAddSecond,
          secondName: value.name
        }
        console.log('data',data)
        this.$http.post(`/order/saveSecondType`, data , { headers: {
            token: window.sessionStorage.manageToken,
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            // this.shopOptions = res.data;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.dialogAddSecond = false
              this.findOrderInfo();
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      addFoodName(){
        const value = this.smallTypes.find((item,index)=>{
          return item.id === this.secondNameForFoodName
        })
        const lastValue = this.foodNames.find((item,index)=>{
          return item.id === this.lastNameForFoodName
        })
        const data = {
          infoSecondId: this.addFoodNameId,
          lastId: this.lastNameForFoodName,
          lastName: lastValue.name
        }
        console.log('data',data)
        this.$http.post(`/order/saveLastType`, data , { headers: {
            token: window.sessionStorage.manageToken,
          }})
          .then(res => {
            console.log('res====',res)
            console.log('resdata====',res.data)
            //  console.log("输出response.data", res.data);
            // this.shopOptions = res.data;
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.dialogAddFoodName = false
              this.findOrderInfo();
            } else {
              this.$message.error(res.data.data)
            }
          });
      },


    },
    watch: {
      dialogTableVisible(newVal){
        if(!newVal){
          this.imageRadioId = '';
          this.currentPage = 1;
          this.firstName = '';
          this.secondName = '';
          this.lastName = '';
        }
      },
      dialogAddSecond(newVal){
        if(!newVal){
         this.firstNameForAddSecond = '';
         this.secondNameForAddSecond = '';
        }
      },
      dialogAddFoodName(newVal){
        if(!newVal){
          this.firstNameForFoodName = '';
          this.secondNameForFoodName = '';
          this.lastNameForFoodName = '';
        }
      },
    },
    filters: {

    },
    computed: {
      imageSrcList() {
        let data = [];
        this.imgDataList.forEach(item => {
          data.push(this.baseURL + '/images'+item.imgUrl);
        })
        return data;
      }
    }
  };
</script>
<style lang="less" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: 10px;
    /*margin-bottom: 20px;*/
    overflow: auto;
    .content-top {
      display: flex;
      margin-top: 10px;
      justify-content: flex-start;
      flex-direction: column;
    }
    .content-bottom {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;
    }
  }
  .first-line {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }
  .label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /*text-align: right;*/
    font-size: 16px;
    color: #000000;
    padding-right: 10px;
  }
  .date-box {
    display: flex;
    align-items: center;
    padding-left: 12px;
  }
  .third-line {
    margin-left: 20px;
    margin-top: 10px;
  }
  .content-box {
    display: flex;
    flex-direction: column;
  }
  .food-content {
    /*flex:1;*/
    display: flex;
    flex-direction: column;
    /*flex-wrap: wrap;*/
    /*justify-content: flex-start;*/
    margin: 10px;
    margin-bottom: 0;
    font-size: 12px;
    overflow: auto;
    .secondName {
      background-color: rgb(111,161,212);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      height: 38px;
      font-size: 16px;
      position: relative;
      .button-box {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .food-box {
    display: flex;
    flex-direction: column;
    width: 230px;
    margin: 0 40px 10px 0;
    position: relative;
    /deep/ .el-checkbox {
      position: absolute;
      top: 5px;
      left: 5px;
    }
    /deep/ .el-checkbox__label {
      display: none;
    }
  }
  .food-image {
    width: 100%;
    height: 200px;
    object-fit: contain;;//转化不同类型
    /*padding: 3px;*/
    /*background-color: #999;*/
    /*box-sizing: border-box;*/
  }
  .image-size {
    display: flex;
    background-color: #999;
    padding: 3px 0 4px;
    align-items: center;
    justify-content: center;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      .image-label {
        display: flex;
        background-color: #ccc;
        width: 40px;
        padding: 3px 10px;
        border-radius: 20px;
        background-color: rgb(225,229,238);
        &:first-child {
          margin-right: 10px;
        }
      }
      .image-value {
        display: flex;
        flex: 1;
        background-color: #fff;
        padding: 3px;
        border-radius: 0 10px 10px 0;
      }
    }
  }
  .image-desc {
    display: flex;
    flex-direction: column;
    .big-type {
      font-size: 14px;
      text-align: left;
      padding: 3px 0 3px 10px;
      border: 3px solid #ccc;
    }
    .image-info {
      font-size: 14px;
      border: 3px solid #ccc;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ccc;
      .info-item{
        flex: 1;
        /*display: flex;*/
        background-color: #fff;
        margin-right: 5px;
      }
    }
  }
  /deep/ .cell {
    text-align: center;
  }
  /deep/ .el-tooltip.copy  {
    margin-right: 0!important;
    width: auto!important;
  }
  .dialog-image-box {
    display: flex;
    flex-wrap: wrap;
  }
  .dialog-image-item {
    width: 150px;
    height: 150px;
    padding: 5px;
    position: relative;
    /deep/ img {
      width: 100%;
      height: 100%;
      object-fit: contain;;//转化不同类型
    }
    .image-radio {
      position: absolute;
      top: 10px;
      left: 10px;
      /deep/ .el-radio__label {
        display: none;
      }
    }
  }
</style>
